import { UI_FIELD_DEFAULT_OPTION, sizeTokenOptionsWithDefault } from './token-options.js';
export const CHIP_FIELDS = [
    {
        key: 'chip.paddingX',
        group: '칩',
        label: '좌우 안쪽 여백',
        help: '선택 칩(PressableChip — 카테고리 선택, 채팅·정산 필터 등 둥근 선택 버튼) 글자 양옆의 여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 10.5px·웹 12px)'),
    },
    {
        key: 'chip.paddingY',
        group: '칩',
        label: '위아래 안쪽 여백',
        help: '선택 칩 글자 위아래의 여백 — 칩 높이가 이만큼 바뀐다',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 7px·웹 8px)'),
    },
    {
        key: 'chip.radius',
        group: '칩',
        label: '모서리 둥글기',
        help: '선택 칩의 모서리 둥글기. 토큰 radius.full이면 양끝이 완전히 둥근 알약 모양',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.full',
        min: 0,
        max: 40,
    },
    {
        key: 'chip.fontSize',
        group: '칩',
        label: '글자 크기',
        help: '선택 칩 글자 크기',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 10,
        max: 20,
    },
    {
        key: 'chip.selectedColor',
        group: '칩',
        label: '선택된 칩 색',
        help: '선택된 칩의 바탕·테두리·글자 색. 브랜드는 라이트 모드 검정 바탕·흰 글자(다크 모드는 반대), 파랑은 파란 바탕·흰 글자. 선택되지 않은 칩은 그대로',
        type: 'enum',
        defaultValue: 'brand',
        options: [
            { value: 'brand', label: '브랜드 (background.brand.primary)' },
            { value: 'info', label: '파랑 (background.semantic.info.bold)' },
        ],
    },
    {
        key: 'chip.bar.gap',
        group: '카테고리 칩 줄',
        label: '칩 사이 간격',
        help: '가로로 넘겨 보는 카테고리 칩 줄(SingleSelectCategoryBar)의 칩 사이 간격',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 간격 (앱 7px·웹 8px)'),
    },
    {
        key: 'chip.bar.paddingX',
        group: '카테고리 칩 줄',
        label: '줄 양끝 여백',
        help: '카테고리 칩 줄의 첫 칩 왼쪽과 마지막 칩 오른쪽 여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 14px·웹 16px)'),
    },
];
//# sourceMappingURL=chip.js.map